import { useState } from "react";
import { Loader, Modal } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import "modules/AgreementsDashboard/components/AgreementsModal/AgreementsModal.scss";
import { AgreementsForm } from "modules/AgreementsDashboard/components/AgreementsModal/components";
import { useCreateAgreementMutation, useUpdateAgreementMutation } from "modules/AgreementsDashboard/hooks";

import type { CommunicationAgreement } from "models";

type AgreementsModalProps = {
  isOpen: boolean;
  isFetchingAgreements: boolean;
  agreement?: CommunicationAgreement;
  onClose: () => void;
};

const FormHelper = createFormHelper<CommunicationAgreement>();

export const AgreementsModal = ({ isOpen, onClose, isFetchingAgreements, agreement }: AgreementsModalProps) => {
  const [hasErrors, setHasErrors] = useState(false);

  const { mutateAsync: handleEditAgreement, isPending: isEditAgreementPending } = useUpdateAgreementMutation();
  const { mutateAsync: handleCreateAgreement, isPending: isCreateAgreementPending } = useCreateAgreementMutation();

  const handleClose = () => {
    onClose();
    setHasErrors(false);
  };

  const validateForm = (values: CommunicationAgreement) => {
    const hasErrors = !values.name || !values.text;
    setHasErrors(hasErrors);
    return hasErrors;
  };

  const handleSubmit = async (values: CommunicationAgreement) => {
    if (validateForm(values)) return;

    if (agreement?.id === -1) {
      await handleCreateAgreement({ ...values });
    } else await handleEditAgreement({ ...agreement, ...values });

    handleClose();
  };

  if (isFetchingAgreements) return <Loader active inline="centered" />;

  return (
    <Modal open={isOpen} size="large" className="AgreementsModal">
      <FormHelper.Form onSubmit={handleSubmit} defaultValues={agreement}>
        <AgreementsForm hasErrors={hasErrors} isPending={isCreateAgreementPending || isEditAgreementPending} onClose={handleClose} agreement={agreement} />
      </FormHelper.Form>
    </Modal>
  );
};
